import { DesignSystem } from '@/src/design-system'
import { H4, Paragraph, XStack, YStack } from 'tamagui'
import type { ComponentProps } from 'react'
import { mesaColorNames } from '../theme'
import { openInAppBrowser } from '../utils/openInAppBrowser'
import { ChevronRight } from '@/src/assets/icons/ChevronRight'
import { TouchableOpacity } from 'react-native'

export function ShutdownNotice({ style }: Pick<ComponentProps<typeof YStack>, 'style'>) {
  const onPressFAQ = () => {
    void openInAppBrowser('https://www.mesamember.com/card', 'FAQ')
  }
  return (
    <YStack gap="$4" style={style}>
      <DesignSystem.Card style={{ backgroundColor: mesaColorNames['Acre Turquoise/500 #00DFC9'] }}>
        <YStack gap="$2">
          <Paragraph>
            Effective as of December 12, 2025, all Mesa Homeowners Card accounts are closed.
          </Paragraph>
          <Paragraph>
            All credit cards have been deactivated and you are no longer able to make any new
            purchases or earn Mesa Points.
          </Paragraph>
        </YStack>
      </DesignSystem.Card>
      <TouchableOpacity
        onPress={onPressFAQ}
        accessibilityLabel="Open FAQ"
        accessibilityRole="button"
      >
        <DesignSystem.Card>
          <XStack items="center" justify="space-between">
            <H4>FAQ</H4>
            <ChevronRight size={24} />
          </XStack>
        </DesignSystem.Card>
      </TouchableOpacity>
    </YStack>
  )
}
